import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

import { SELLER_COLLECTS_NS } from '../sellerCollectsBidCopy'
import { sellerNameValue } from './sellerNameValue'

const Note = styled.p`
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.dark_grey};
  margin: 0.5rem 0 0;
`

/**
 * Says in words what the grouped total only implies: two payments, two
 * parties, two invoices. Fee-free storefronts have one of each, so the
 * caller renders this only for a fee-bearing lot.
 */
export const SellerCollectsTotalNote = ({
  sellerName,
  sellerInvoicesBuyer,
  paysViaRep = false,
}: {
  /** Empty where the seller cannot be named; generic copy fills in. */
  sellerName: string
  /**
   * From the storefront. Only an explicit `false` drops the invoice claim —
   * an unset flag is not a promise that the seller sends nothing.
   */
  sellerInvoicesBuyer?: boolean
  /**
   * A storefront settled through a representative sends no invoice whatever
   * the flag says, and the steps a few lines up already say so.
   */
  paysViaRep?: boolean
}) => (
  <Note data-testid="seller-collects-total-note">
    <FormattedMessage
      id={`${SELLER_COLLECTS_NS}.total.${
        sellerInvoicesBuyer === false || paysViaRep
          ? 'twoPaymentsNoInvoice'
          : 'twoPayments'
      }`}
      values={{ sellerName: sellerNameValue(sellerName) }}
    />
  </Note>
)
